const phoneCompanies = [
    {
        value: 1,
        name: 'PERSONAL'
    },
    {
        value: 2,
        name: 'MOVISTAR'
    },
    {
        value: 3,
        name: 'TUENTI'
    },
    {
        value: 4,
        name: 'CLARO'
    },
]
const rowPhones = [
    {
        indx: 1,
        title: 'Teléfono Contácto'
    },
    {
        indx: 2,
        title: 'Teléfono Contácto Alternativo (Opcional)'
    }
]

const messages = {
    create: 'Asegurado registrado exitosamente como usuario!',
    update: 'Usuario modificado exitosamente!',
    error: 'Se produjo un error al realizar el registro. Inténtelo nuevamente'
}


export { phoneCompanies, messages }